import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Assets from '../../helpers/Assets';
import t from '../../lib/I18n';
import ApplePayPayment from '../../records/order/ApplePayPayment';


const ApplePayPaymentDetails = ({ small, payment }) => (
    <span className={ classnames('payment-details', { 'payment-details--small': small }) }>
        <img className="payment-details__image payment-details__image--apple-pay" src={ Assets.assetUrl("images/apple-pay-only-logo-small.png") } alt="Apple Pay logo" />
        <span className="payment-details__account-name payment-details__account-name--apple-pay">{ t('payment.details.applePay', { applePayAccount: payment.pan }) }</span>
    </span>
);

ApplePayPaymentDetails.propTypes = {
    payment: PropTypes.instanceOf(ApplePayPayment).isRequired,
    small: PropTypes.bool
};

ApplePayPaymentDetails.defaultProps = {
    small: false
};

export default ApplePayPaymentDetails;
